const Appdefs = window.cccisd.appDefs;
const Env = window.cccisd.env;
const wpUrl = (Env.wpUrl || Appdefs.app.wpUrl).replace('//$/', ''); // remove trailing slash

export default wpUrl;
